import React from "react";
import { Ear, Compass, Clock, HeartHandshake } from "lucide-react";

const items = [
    { icon: Ear, title: "We listen", text: "Our clients aren't just numbers — we take time to understand your goals, lifestyle and long-term plans." },
    { icon: Compass, title: "Informed decisions", text: "Honest, independent finance advice tailored to your circumstances. No pressure, no jargon." },
    { icon: Clock, title: "Save time", text: "One broker, one process. We negotiate with 60+ lenders so you don't have to chase the banks." },
    { icon: HeartHandshake, title: "Long-term support", text: "We don't disappear after settlement — annual reviews keep your loan competitive over time." }
];

export const WhyChooseUs = () => {
    return (
        <section data-testid="why-choose-us" className="bg-background">
            <div className="container-prose py-24">
                <div className="max-w-2xl mb-16">
                    <div className="overline">Why Finance Wealth</div>
                    <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] text-[#1A362B] font-medium">
                        There's no one quite like us.
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-border">
                    {items.map((it, i) => (
                        <div key={it.title} data-testid={`why-item-${i}`} className="bg-background p-8 md:p-10 group hover:bg-[#F3F1EA] transition-colors">
                            <div className="w-11 h-11 rounded-sm bg-[#1A362B] text-white grid place-items-center">
                                <it.icon className="w-5 h-5" />
                            </div>
                            <h3 className="mt-6 font-serif text-2xl text-[#1A362B] tracking-tight">{it.title}</h3>
                            <p className="mt-3 text-sm text-[#1C1C1C]/70 leading-relaxed">{it.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
